import React from 'react';
import { observer } from 'mobx-react';
import { EvaluateButtonsWrapper } from '@seedlang/hoc';
import { DeckUI } from '@seedlang/state';
import { Theme } from '@seedlang/constants';
import { BigSmileFaceIcon, NeutralFaceIcon, SmileFaceIcon } from '@seedlang/icons';
import CardButtons from 'components/card/card_buttons';
import CardButton from 'components/card/card_button';
import NextButton from 'components/button/next_button';

@observer
class EvaluateButtons extends React.Component {

  render() {
    if (!DeckUI.reviewDeck) {
      return (
        <CardButtons>
          <NextButton
            disabled={this.props.disabled}
            onClick={this.props.onNextClick}
            submitOnEnter
            shortcut='1'
          />
        </CardButtons>
      );
    }

    return (
      <CardButtons>
        <CardButton
          shortcut='1'
          text='Hard'
          backgroundColor={Theme.darkestGreen}
          icon={<NeutralFaceIcon />}
          onClick={() => this.props.onHardClick()}
          subText={this.props.hardButtonSubText}
          disabled={this.props.disabled}
          marginRight={5}
        />
        <CardButton
          shortcut='2'
          text='Good'
          backgroundColor={Theme.mediumGreen}
          icon={<SmileFaceIcon />}
          onClick={() => this.props.onGoodClick()}
          subText={this.props.goodButtonSubText}
          disabled={this.props.disabled}
          marginRight={5}
          marginLeft={5}
        />
        {
          this.props.showEasyButton &&
            <CardButton
              shortcut='3'
              text={this.props.easyButtonRetiresCard ? 'Retire' : 'Easy'}
              backgroundColor={this.props.easyButtonRetiresCard ? Theme.purple : Theme.green}
              icon={<BigSmileFaceIcon />}
              onClick={() => this.props.onEasyClick()}
              subText={this.props.easyButtonSubText}
              disabled={this.props.disabled}
              marginLeft={5}
            />
        }
      </CardButtons>
    );
  }
}

export default EvaluateButtonsWrapper(EvaluateButtons);
